import { Teacher } from './Teacher'

// 매쓰플랫 사용하는 선생님 유저
export class User extends Teacher {
  constructor({ teacher }: { teacher?: res.Teacher }) {
    super(teacher)

    Object.assign(this)
  }
}
